module.exports = __webpack_public_path__ + "fonts/fa-solid-900.38b88d1.woff";